import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { environment } from "../../environments/environment";
import { ProgramListViewModel, DataTablesQuery, ResponseMessage } from "@models/common";
import { Program, ProgramPublicProfile } from "@models/program";
import { ProgramRequest } from "@models/requests";
import { DeleteRequest, RequestListItem, RequestListResponse, EditRequestComparison } from "@models/requests";
import { ActNowHttp } from "../act-now.http";

@Injectable()
export class RequestService {
    public apiUrl: string = environment.apiUrl;
    private headers = new Headers({ "Content-Type": "application/json", "Accept": "application/json;charset=UTF-8" });

    constructor(private http: Http, private actnowHttp: ActNowHttp) { }

    //#region Admin Endpoints

    //#region Add Request
    getAdditionRequestForReview(id: number): Observable<Program> {
        return this.actnowHttp.get(this.apiUrl + "Request/Add/" + id)
            .map((response: Response) => <Program>response.json())
            .catch(this.handleError);
    }

    approveAddition(id: number, model: Program): Observable<ResponseMessage> {
        return this.actnowHttp.put(this.apiUrl + "Request/Add/" + id, JSON.stringify(model))
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    //#endregion

    //#region Edit Request
    getEditRequestForReview(id: number): Observable<EditRequestComparison> {
        return this.actnowHttp.get(this.apiUrl + "Request/Edit/" + id)
            .map((response: Response) => <EditRequestComparison>response.json())
            .catch(this.handleError);
    }

    approveEdit(id: number, model: Program): Observable<ResponseMessage> {
        return this.actnowHttp.put(this.apiUrl + "Request/Edit/" + id, JSON.stringify(model))
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    //#endregion

    //#region Delete Request
    getDeleteRequestForReview(id: number): Observable<DeleteRequest> {
        return this.actnowHttp.get(this.apiUrl + "Request/Delete/" + id)
            .map((response: Response) => <DeleteRequest>response.json())
            .catch(this.handleError);
    }

    approveDelete(id: number, model: DeleteRequest): Observable<ResponseMessage> {
        return this.actnowHttp.put(this.apiUrl + "Request/Delete/" + id, JSON.stringify(model))
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    submitProgramDeleteRequest(model: DeleteRequest): Observable<ResponseMessage> {
        return this.http.post(this.apiUrl + "Request/Delete", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    //#endregion

    denyRequest(id: number): Observable<ResponseMessage> {
        return this.actnowHttp.delete(this.apiUrl + "Request/" + id)
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    filterRequestList(model: DataTablesQuery): Observable<RequestListResponse> {
        return this.actnowHttp.post(this.apiUrl + "Request/", JSON.stringify(model))
            .map((response: Response) => <RequestListResponse>response.json())
            .catch(this.handleError);
    }
    //#endregion

    //#region Public Endpoints
    public getEditableProgram(id): Observable<Program> {
        return this.http.get(this.apiUrl + "Program/Edit/" + id, { headers: this.headers })
            .map((response: Response) => <Program>response.json())
            .catch(this.handleError);
    }

    public submitEditRequest(model: Program): Observable<ResponseMessage> {
        return this.http.post(this.apiUrl + "Request/Edit", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    public submitProgramAdditionRequest(model: Program): Observable<ResponseMessage> {
        return this.http.post(this.apiUrl + "Request/Add", JSON.stringify(model), { headers: this.headers })
            .map((response: Response) => <ResponseMessage>response.json())
            .catch(this.handleError);
    }

    //#endregion

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json() || "Server Error");
    }
}



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/requests/request.service.ts